import React from 'react'
import Svg from 'react-native-svg'

export const VerifiedIcon = ({
  height = 20,
  width = 20,
  color = '#00C113',
}: {
  height?: any
  width?: any
  color?: any
}) => {
  return (
    <Svg id="Verified_Icon" width={width} height={height} viewBox="0 0 25 25">
      <path
        id="Path_1950"
        data-name="Path 1950"
        d="M8.559-9.441a1.5,1.5,0,0,1-2.119,0l-3.751-3.75a1.5,1.5,0,0,1,0-2.119,1.5,1.5,0,0,1,2.12,0l2.648,2.686,6.483-6.437a1.5,1.5,0,0,1,2.119,0,1.5,1.5,0,0,1,0,2.122Zm0,10.5a1.5,1.5,0,0,1-2.119,0l-6-6a1.5,1.5,0,0,1,0-2.119,1.5,1.5,0,0,1,2.121,0l4.9,4.936L18.441-13.059a1.5,1.5,0,0,1,2.119,0,1.5,1.5,0,0,1,0,2.119l-12,12Z"
        transform="translate(0 19.5)"
        fill={color}
      />
    </Svg>
  )
}
